/* Non-PII Clarity milestones. Never send field values or free-text labels. */
(function () {
  'use strict';
  if (window.__nhlFormFunnel) return;
  window.__nhlFormFunnel = true;

  var sent = Object.create(null);
  var pending = [];
  var pageStartedAt = Date.now();
  var active = Object.create(null);
  var TIMING_PREFIX = 'nhl:funnel:timing:v1:';

  function dispatch(name) {
    if (!name || sent[name]) return;
    sent[name] = true;
    if (typeof window.clarity === 'function') {
      try { window.clarity('event', name); return; } catch (_) {}
    }
    pending.push({ type: 'event', name: name });
  }

  function setTag(name, value) {
    if (!name || !value) return;
    if (typeof window.clarity === 'function') {
      try { window.clarity('set', name, value); return; } catch (_) {}
    }
    pending.push({ type: 'set', name: name, value: value });
  }

  function flush() {
    if (typeof window.clarity !== 'function' || !pending.length) return;
    var queue = pending;
    pending = [];
    queue.forEach(function (item) {
      try {
        if (item.type === 'set') window.clarity('set', item.name, item.value);
        else window.clarity('event', item.name);
      } catch (_) { pending.push(item); }
    });
  }

  function safeSlug(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 40);
  }

  function safeTagValue(value, fallback) {
    var result = String(value || '').replace(/[^a-zA-Z0-9_. -]+/g, '_').slice(0, 80);
    return result || fallback || 'unknown';
  }

  function timeBucket(milliseconds) {
    if (!Number.isFinite(milliseconds) || milliseconds < 0) return 'unknown';
    if (milliseconds < 10000) return 'under_10s';
    if (milliseconds < 30000) return '10_30s';
    if (milliseconds < 120000) return '30_120s';
    return '120s_plus';
  }

  function journeyPage(pathname) {
    var path = String(pathname || location.pathname).replace(/\/+$/, '') || '/';
    path = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
    if (path === '/') return 'home';
    if (path === '/pages/gallery') return 'gallery';
    if (path === '/pages/custom-watches') return 'custom_watches';
    if (path === '/pages/commission') return 'commission';
    if (path === '/pages/contact-us') return 'contact';
    if (/^\/collections\//.test(path)) return 'catalogue';
    if (/^\/products\//.test(path)) return 'product';
    return 'other';
  }

  function emitJourneyContext() {
    var page = journeyPage();
    setTag('journey_page', page);
    if (page !== 'other') dispatch('journey_' + page + '_viewed');
  }

  function applyAttributionTags() {
    var touch = null;
    try {
      var saved = JSON.parse(localStorage.getItem('nhl:inquiry:attribution:v1') || 'null');
      touch = saved && saved.last;
    } catch (_) {}
    var values = touch && Array.isArray(touch.values) ? touch.values : [];
    var clicks = touch && Array.isArray(touch.googleClicks) ? touch.googleClicks : [];
    setTag('traffic_source', safeTagValue(values[0], 'direct'));
    setTag('traffic_medium', safeTagValue(values[1], 'none'));
    setTag('traffic_campaign', safeTagValue(values[2], 'none'));
    setTag('traffic_placement', safeTagValue(values[5], 'none'));
    setTag('landing_path', safeTagValue(touch && touch.landingPath, safeTagValue(location.pathname, 'unknown')));
    setTag('google_click_id_present', clicks.some(function (value) { return !!value; }) ? 'yes' : 'no');
  }

  function trackGlobalLinks() {
    document.addEventListener('click', function (event) {
      var anchor = event.target.closest && event.target.closest('a');
      if (!anchor) return;
      var href = anchor.getAttribute('href') || '';
      if (/^mailto:/i.test(href)) { dispatch('contact_email_clicked'); return; }
      if (/^tel:/i.test(href)) { dispatch('contact_phone_clicked'); return; }
      var url;
      try { url = new URL(href, location.href); } catch (_) { return; }
      if (/instagram\.com$/i.test(url.hostname) || /\.instagram\.com$/i.test(url.hostname)) {
        dispatch('contact_instagram_clicked');
        return;
      }
      if (url.origin !== location.origin) return;
      var destination = journeyPage(url.pathname);
      if (destination !== 'other' && destination !== journeyPage()) {
        dispatch('journey_cta_to_' + destination + '_clicked');
      }
    });
  }

  function timingKey(prefix) {
    return TIMING_PREFIX + prefix + ':' + location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/pages\/)/i, '');
  }

  function readTiming(prefix) {
    try {
      var record = JSON.parse(sessionStorage.getItem(timingKey(prefix)) || sessionStorage.getItem(TIMING_PREFIX + prefix + ':' + location.pathname) || 'null');
      if (!record || !Number.isFinite(record.pageAt) || Date.now() - record.pageAt < 0 || Date.now() - record.pageAt > 1800000) return null;
      return record;
    } catch (_) { return null; }
  }

  function writeTiming(prefix, state) {
    try {
      sessionStorage.setItem(timingKey(prefix), JSON.stringify({
        pageAt: pageStartedAt,
        startedAt: state.startedAt || 0,
        detailsAt: state.detailsAt || 0,
        submitClickedAt: state.submitClickedAt || 0,
        submittedAt: state.submittedAt || 0,
        lastStep: state.lastStep || 'none',
        submitClicks: state.submitClicks || 0,
        budgetGuidanceSeen: !!state.budgetGuidanceSeen
      }));
    } catch (_) {}
  }

  function applyTimingTags(prefix, record) {
    if (!record) return;
    if (record.startedAt) setTag(prefix + '_time_to_start', timeBucket(record.startedAt - record.pageAt));
    if (record.detailsAt && record.startedAt) setTag(prefix + '_time_to_details', timeBucket(record.detailsAt - record.startedAt));
    if (record.submittedAt && record.startedAt) setTag(prefix + '_time_to_submit', timeBucket(record.submittedAt - record.startedAt));
    setTag(prefix + '_last_step', safeTagValue(record.lastStep, 'none'));
    if (record.submitClicks > 1) dispatch(prefix + '_duplicate_submit');
  }

  function pendingInquiryRecord(formId) {
    var path = location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/pages\/)/i, '');
    var keys = [
      'nhl:lead:pending:v2:' + formId + ':' + path,
      'nhl:lead:pending:' + formId + ':' + location.pathname
    ];
    for (var i = 0; i < keys.length; i++) {
      try {
        var record = JSON.parse(sessionStorage.getItem(keys[i]) || 'null');
        if (record && /^NHL-[0-9a-f-]{36}$/i.test(record.id || '')) return record;
      } catch (_) {}
    }
    return null;
  }

  function fieldKey(field) {
    if (!field) return 'required_field';
    var name = field.name || '';
    if (name === 'contact[email]') return 'email';
    if (name === 'contact[name]') return 'name';
    if (name === 'contact[body]') return 'message';
    if (field.matches('[data-lp-budget]')) return 'budget';
    if (field.matches('[data-lp-timing]')) return 'timing';
    if (field.matches('[data-lp-phone]')) return 'phone';
    if (field.matches('[data-lp-call-consent]')) return 'call_consent';
    if (name === 'contact[Preferred completion date]') return 'preferred_date';
    if (name === 'contact[Instagram handle]') return 'instagram';
    if (field.dataset && field.dataset.label) return safeSlug(field.dataset.label);
    var group = field.closest && field.closest('[data-step]');
    if (group) return safeSlug(group.getAttribute('data-step')) || 'configuration';
    return 'required_field';
  }

  function markStep(state, prefix, step) {
    state.lastStep = safeSlug(step) || 'unknown';
    writeTiming(prefix, state);
  }

  function observeOnce(selector, eventName, threshold) {
    var marker = document.querySelector(selector);
    if (!marker || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (items) {
      if (items[0].isIntersecting) { dispatch(eventName); observer.disconnect(); }
    }, { threshold: threshold || 0.1 });
    observer.observe(marker);
  }

  function faqTopic(question) {
    var text = String(question || '').toLowerCase();
    if (/cost|price/.test(text)) return 'pricing';
    if (/customis|customiz|adapt/.test(text)) return 'customisation';
    if (/commit|purchase/.test(text)) return 'commitment';
    if (/how long|take/.test(text)) return 'lead_time';
    if (/ship/.test(text)) return 'shipping';
    if (/warrant|guarantee/.test(text)) return 'warranty';
    if (/technical|specification/.test(text)) return 'technical_specs';
    if (/provide|need/.test(text)) return 'requirements';
    return 'other';
  }

  function selectedCategory(field, categories) {
    return field && field.selectedIndex > 0 ? categories[field.selectedIndex - 1] || 'other' : 'none';
  }

  function trackCommissionContent() {
    if (journeyPage() !== 'custom_watches') return;
    setTag('commission_tracking_version', 'v2_2026_09_30');
    observeOnce('.lp-early-proof-maker', 'commission_maker_proof_seen', 0.1);
    observeOnce('.lp-early-proof-feature', 'commission_feature_proof_seen', 0.1);
    observeOnce('.lp-faq', 'commission_faq_seen', 0.1);
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('.lp-early-proof-maker a')) dispatch('commission_maker_story_clicked');
      if (target.closest('.lp-early-proof-feature a')) dispatch('commission_feature_clicked');
      if (target.closest('#commission-form .lp-gallery-callout a')) dispatch('commission_gallery_inspiration_clicked');
      if (target.closest('[data-inspiration-toggle]')) dispatch('commission_inspiration_opened');
    });
    document.addEventListener('toggle', function (event) {
      var item = event.target;
      if (!item.matches || !item.matches('.lp-faq details') || !item.open || !event.isTrusted) return;
      dispatch('commission_faq_opened');
      var summary = item.querySelector('summary');
      dispatch('commission_faq_' + faqTopic(summary && summary.textContent) + '_opened');
    }, true);
  }

  function bind(form, prefix) {
    if (!form || form.__nhlFunnelBound) return;
    form.__nhlFunnelBound = true;
    var state = { startedAt: 0, detailsAt: 0, submitClickedAt: 0, submittedAt: 0, lastStep: 'none', submitClicks: 0, submitAttempted: false, success: false, path: 'simple', budgetGuidanceSeen: false };
    active[prefix] = state;
    setTag(prefix + '_form_present', 'yes');
    dispatch(prefix + '_viewed');
    if (prefix === 'commission') {
      setTag('commission_page_version', 'v5_guided_2026_09_30');
      var ref = new URLSearchParams(location.search).get('gallery_ref');
      if (ref && /^[a-zA-Z0-9_-]{1,160}$/.test(ref)) dispatch('commission_gallery_return_seen');
      observeOnce('#commission-form .lp-mode', 'commission_section_seen', 0.5);
      observeOnce('#comm-details .comm-legend', 'commission_contact_seen', 0.5);
      document.addEventListener('click', function (event) {
        var heroPath = event.target.closest && event.target.closest('.lp-intro [data-lp-mode]');
        if (heroPath) {
          var heroRoute = heroPath.dataset.lpMode === 'detailed' ? 'specs' : 'simple';
          dispatch('commission_hero_' + heroRoute + '_clicked');
          dispatch('commission_' + heroRoute + '_path_used');
          state.path = heroRoute;
        }
      });
    }

    // Exposure means >=50% of the note visible for one continuous second in an active tab.
    // Never infer abandonment from a tab switch; exit events are best effort only.
    var guidance = form.querySelector('[data-lp-budget-guidance]');
    var guidanceBudget = form.querySelector('[data-lp-budget]');
    if (prefix === 'commission' && guidance && guidanceBudget && 'IntersectionObserver' in window) {
      var guidanceInView = false, guidanceTimer = null;
      function cancelGuidanceTimer() { clearTimeout(guidanceTimer); guidanceTimer = null; }
      function checkGuidanceExposure() {
        cancelGuidanceTimer();
        if (state.budgetGuidanceSeen || guidance.hidden || !guidanceInView || document.visibilityState !== 'visible') return;
        guidanceTimer = setTimeout(function () {
          if (guidance.hidden || !guidanceInView || document.visibilityState !== 'visible') return;
          state.budgetGuidanceSeen = true;
          if (new URLSearchParams(location.search).get('qa') === 'budget-tracking-20261004') guidance.setAttribute('data-nhl-guidance-tracked', 'yes');
          dispatch('commission_budget_guidance_seen');
          setTag('commission_budget_guidance_seen', 'yes');
          setTag('commission_budget_guidance_path', form.classList.contains('lp-simple') ? 'simple' : 'specs');
          writeTiming(prefix, state);
        }, 1000);
      }
      new IntersectionObserver(function (items) {
        guidanceInView = items[0].isIntersecting && items[0].intersectionRatio >= 0.5;
        checkGuidanceExposure();
      }, { threshold: [0, 0.5] }).observe(guidance);
      new MutationObserver(checkGuidanceExposure).observe(guidance, { attributes: true, attributeFilter: ['hidden'] });
      document.addEventListener('visibilitychange', checkGuidanceExposure);
      guidanceBudget.addEventListener('change', function () {
        checkGuidanceExposure();
        if (state.budgetGuidanceSeen && guidanceBudget.selectedIndex >= 2 && guidanceBudget.selectedIndex <= 5) {
          dispatch('commission_budget_raised_after_guidance');
        }
      });
    }

    var success = !!form.querySelector('.comm-success, .tick-row');
    if (success) {
      state.success = true;
      // A visual-only Shopify success preview must not count as a submitted enquiry.
      if (new URLSearchParams(window.location.search).get('nhl_demo') !== 'thank_you') {
        dispatch(prefix + '_form_success');
        var timing = readTiming(prefix);
        applyTimingTags(prefix, timing);
        if (prefix === 'commission' && timing && timing.budgetGuidanceSeen && timing.submittedAt) {
          dispatch('commission_success_after_budget_guidance');
          setTag('commission_budget_guidance_seen', 'yes');
        }
        setTag(prefix + '_status', 'success');
        var inquiry = pendingInquiryRecord(form.id);
        if (inquiry) setTag('inquiry_id', inquiry.id);
      }
    }

    var serverError = !!form.querySelector('.comm-errors, [role="alert"]');
    if (serverError) {
      dispatch(prefix + '_form_error');
      dispatch(prefix + '_server_error');
      setTag(prefix + '_error_type', 'shopify_form_error');
    }

    function start() {
      if (state.startedAt) return;
      state.startedAt = Date.now();
      dispatch(prefix + '_started');
      setTag(prefix + '_time_to_start', timeBucket(state.startedAt - pageStartedAt));
      markStep(state, prefix, 'starting_point');
    }

    form.addEventListener('focusin', function (event) {
      var field = event.target.closest && event.target.closest('input, select, textarea');
      if (!field || field.type === 'hidden') return;
      start();
      if (prefix === 'commission' && field.closest('#comm-details')) {
        if (!state.detailsAt) {
          state.detailsAt = Date.now();
          dispatch('commission_details_started');
          setTag('commission_time_to_details', timeBucket(state.detailsAt - state.startedAt));
        }
        markStep(state, prefix, fieldKey(field));
        if (form.classList.contains('lp-simple')) dispatch('commission_simple_path_used');
      }
      if (prefix === 'contact' && field.name === 'contact[body]') {
        dispatch('contact_message_started');
        markStep(state, prefix, 'message');
      }
    });

    form.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.type === 'hidden') return;
      // URL preselection and preset hydration dispatch synthetic changes on page load.
      if (!event.isTrusted && !state.startedAt) return;
      start();
      if (prefix !== 'commission') return;
      if (target.matches('[data-lp-budget]') && target.value) {
        dispatch('commission_budget_selected');
        setTag('commission_budget_ever_selected', selectedCategory(target, ['under_900', '900_1200', '1200_1800', '1800_3000', '3000_plus', 'unsure']));
      }
      if (target.matches('[data-lp-timing]') && target.value) {
        dispatch('commission_timing_selected');
        setTag('commission_timing_ever_selected', selectedCategory(target, ['ready', 'one_to_three_months', 'target_date', 'exploring']));
      }
      if (target.name === 'contact[body]' && target.value.trim()) dispatch('commission_message_entered');
      var group = target.closest('[data-step]');
      var step = group && safeSlug(group.getAttribute('data-step'));
      if (step) {
        dispatch('commission_step_' + step + '_selected');
        markStep(state, prefix, step);
      }
      if (target.dataset.label === 'Build type') {
        dispatch('commission_build_type_selected');
        setTag('commission_project_type', safeSlug(target.value));
      }
      if (target.closest('[data-key="quantity"]')) dispatch('commission_quantity_selected');
    });
    if (prefix === 'commission') form.addEventListener('input', function (event) {
      if (event.target.matches('[data-lp-phone]') && event.target.value.trim()) dispatch('commission_callback_option_opened');
    });

    function recordSubmitClick() {
      start();
      state.submitClicks++;
      state.submitClickedAt = Date.now();
      dispatch(prefix + '_submit_clicked');
      if (state.submitClicks > 1) dispatch(prefix + '_duplicate_submit');
      writeTiming(prefix, state);
    }
    form.addEventListener('click', function (event) {
      var target = event.target;
      var submit = target.closest && target.closest('button[type="submit"], input[type="submit"]');
      if (submit && (!submit.matches('[data-summary-action]') || submit.dataset.summaryStage === 'submit')) recordSubmitClick();
      if (target.closest('[data-summary-action]') && target.closest('[data-summary-action]').dataset.summaryStage === 'continue') {
        start(); dispatch('commission_summary_continue_clicked');
      }
      if (prefix !== 'commission') return;
      var path = target.closest('[data-lp-mode]');
      if (path) {
        start();
        var pathName = path.dataset.lpMode === 'detailed' ? 'specs' : 'simple';
        if (state.path === 'specs' && pathName === 'simple') dispatch('commission_specs_to_simple');
        state.path = pathName;
        dispatch('commission_path_' + pathName + '_selected');
        dispatch('commission_' + pathName + '_path_used');
        markStep(state, prefix, pathName);
      }
      if (target.closest('[data-inspiration-toggle]')) start();
      if (target.closest('[data-lp-next]')) {
        start();
        var chosenType = form.querySelector('input[data-label="Build type"]:checked');
        dispatch(chosenType && chosenType.value === 'Ground-up Custom' ? 'commission_guided_design_opened' : 'commission_guided_brief_continue');
      }
      if (target.closest('[data-lp-to-contact]')) { start(); dispatch('commission_guided_contact_continue'); }
      if (target.closest('[data-skip-to-details]')) {
        dispatch('commission_skip_to_details');
        markStep(state, prefix, 'details');
      }
      var card = target.closest('[data-start] .comm-start-card');
      if (card) {
        start();
        dispatch('commission_starting_point_selected');
        dispatch('commission_preset_selected');
        markStep(state, prefix, 'starting_point');
      }
      var toggle = target.closest('[data-collapsible] [data-toggle]');
      if (toggle) {
        start();
        var stepGroup = toggle.closest('[data-step]');
        var stepName = stepGroup && safeSlug(stepGroup.getAttribute('data-step'));
        if (stepName) {
          dispatch('commission_step_' + stepName + '_opened');
          markStep(state, prefix, stepName);
        }
      }
      if (target.closest('[data-expand-all]')) { start(); dispatch('commission_show_every_option'); }
    });
    if (prefix === 'commission') {
      var advanced = form.querySelector('[data-lp-advanced]');
      if (advanced) advanced.addEventListener('toggle', function () {
        if (advanced.open) { start(); dispatch('commission_technical_details_opened'); }
      });
    }
    if (prefix === 'commission') {
      var stickyAction = document.querySelector('[data-sticky-action]');
      if (stickyAction) stickyAction.addEventListener('click', function () {
        if (stickyAction.dataset.stickyStage === 'continue') { start(); dispatch('commission_sticky_continue_clicked'); }
        else { dispatch('commission_sticky_submit_clicked'); recordSubmitClick(); }
      });
    }

    form.addEventListener('invalid', function (event) {
      var key = fieldKey(event.target);
      dispatch(prefix + '_validation_error');
      dispatch(prefix + '_invalid_' + key);
      setTag(prefix + '_validation_field', key);
      if (state.submitClickedAt && Date.now() - state.submitClickedAt < 3000) dispatch(prefix + '_submit_blocked');
      markStep(state, prefix, key);
    }, true);

    form.addEventListener('submit', function () {
      start();
      if (prefix === 'commission') {
        var submitPath = form.classList.contains('lp-simple') ? 'simple' : 'specs';
        setTag('commission_path_at_submit', submitPath);
        dispatch('commission_' + submitPath + '_path_used');
        setTag('commission_budget_at_submit', selectedCategory(form.querySelector('[data-lp-budget]'), ['under_900', '900_1200', '1200_1800', '1800_3000', '3000_plus', 'unsure']));
        setTag('commission_timing_at_submit', selectedCategory(form.querySelector('[data-lp-timing]'), ['ready', 'one_to_three_months', 'target_date', 'exploring']));
        var instagram = form.querySelector('input[name="contact[Instagram handle]"]');
        if (instagram && instagram.value.trim()) dispatch('commission_instagram_contact_offered');
      }
      var callPhone = form.querySelector('[data-lp-phone]'), callConsent = form.querySelector('[data-lp-call-consent]');
      if (prefix === 'commission' && callPhone && callPhone.value.trim() && callConsent && callConsent.checked) dispatch('commission_callback_requested');
      if (prefix === 'commission' && state.budgetGuidanceSeen) dispatch('commission_submit_after_budget_guidance');
      state.submitAttempted = true;
      state.submittedAt = Date.now();
      dispatch(prefix + '_submit_attempted');
      setTag(prefix + '_time_to_submit', timeBucket(state.submittedAt - state.startedAt));
      writeTiming(prefix, state);
    }, true);
  }

  function trackExit() {
    window.addEventListener('pagehide', function () {
      Object.keys(active).forEach(function (prefix) {
        var state = active[prefix];
        if (state.startedAt && !state.success && !state.submitAttempted) {
          dispatch(prefix + '_exit_before_submit');
          if (prefix === 'commission' && state.budgetGuidanceSeen) dispatch('commission_exit_after_budget_guidance');
          setTag(prefix + '_exit_stage', state.lastStep || 'unknown');
        }
        writeTiming(prefix, state);
      });
    });
  }

  function bindForms() {
    bind(document.getElementById('commission-form'), 'commission');
    bind(document.getElementById('contact-band-form'), 'contact');
    flush();
  }

  emitJourneyContext();
  applyAttributionTags();
  trackGlobalLinks();
  trackCommissionContent();
  trackExit();
  window.nhlFormFunnelTrack = dispatch;
  document.addEventListener('visitorConsentCollected', function () {
    applyAttributionTags();
    flush();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindForms, { once: true });
  else bindForms();

  var timer = setInterval(function () {
    flush();
    if (Date.now() - pageStartedAt > 60000) clearInterval(timer);
  }, 250);
})();
